import { useSignups } from "Signups/state.js";

export function useIsSignupClosed() {
  const [state] = useSignups();

  const isExpired =
    state.currentSignupList?.options?.expireDate > 0 &&
    new Date(state.currentSignupList?.options?.expireDate * 1000) < new Date();

  const isArchived =
    state.currentSignupList && state.currentSignupList.signupListStatusID === 4;

  return { isClosed: Boolean(isExpired || isArchived), isExpired, isArchived };
}
